module.exports = __webpack_public_path__ + "static/img/Group 355.009225c1.png";